import InputPin from './InputPin';

export default InputPin;
